import React from "react";
import { HeldBet } from "@/features/betslip/components/overlays/HeldBet";

export const Intercepted = () => (
  <HeldBet
    message="Your bet is being reviewed by a Trader"
    buttonLabel="In Review"
    testId="intercepted"
  />
);
